import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import Cluster from '../Support/Cluster';

import imgHallChadwickLogo from '../images/powered-by-hall-chadwick-forensics-white.png';
import imgXpediteLogo from '../images/xpedite-logo-white.png';
import imgPrintHCLogo from '../images/printable-hall-chadwick-forensics.png';
import imgPrintXPLogo from '../images/printable-xpedite-logo.png';


class Header extends Component {

	state = {
		menuOpen: false
	}

	toggleMenu = () => {
		this.setState({
			menuOpen: !this.state.menuOpen
		});
	}

	render() {

		let header_right = null;
		let logo_link = '/';
		let print_middle = null;
		let print_link = null;

		const path_regex = /^\/matter\/[a-z]{4}[0-9]{4}\/?$/;
		if(path_regex.test(window.location.pathname) && this.props.matter) {
			print_middle = (
				<div className='print--header__middle'>
					<h1>Matter / {this.props.matter.code}</h1>
				</div>
			);
			print_link = <li className='dropmenu__item'><a href='#print' onClick={(e) => {e.preventDefault(); this.toggleMenu(); window.print();}}>Print Matter</a></li>;
		}


		if(this.props.user !== null) {

			let dropMenu = null;

			if(this.state.menuOpen) {
				dropMenu = (
					<div className='dropmenu'>
						<svg className='dropmenu__pointer fas fa-caret-up' />
						<div className='dropmenu__panel'>
							<ul className='dropmenu__items'>
								<li className='dropmenu__item'><NavLink to='/dashboard'>Dashboard</NavLink></li>
								<li className='dropmenu__item'><NavLink to='/matter/new'>New Matter</NavLink></li>
								{print_link}
								<li className='dropmenu__item'><NavLink to='/reset-password'>Change Password</NavLink></li>
								<li className='dropmenu__item'><NavLink to='/'>About Xpedite</NavLink></li>
								<li className='dropmenu__item'><NavLink to='/logout'>Logout</NavLink></li>
							</ul>
						</div>
					</div>
				);
			}

			header_right = (<div className='header__slot header__slot--right'>
				<div className='header__slot__track'>
					<NavLink to='/matter/new' className='header__slot__btn header__slot__btn--blend btn btn--bordered'>New matter</NavLink>
					<button className='header__slot__btn btn btn--dropper' onClick={this.toggleMenu}>
						<span className='inline--from-small'>{this.props.user.alias.substr(0,10)} </span>
						<span className='inline--until-small'>Menu </span>
						<span className='btn--dropper__icons'><svg className='fas fa-user'></svg> <svg className='fas fa-angle-down'></svg></span></button>
					{dropMenu}
				</div>
			</div>);

			logo_link = '/dashboard';

		}

		return (
			<Cluster>
				<header className='header'>

					<div className='wrapper clearfix'><div className='header__slot header__slot--left'>
							<a className='header__slot__logo' href='http://hallchadwickmelb.com.au' rel='noopener noreferrer' target='_blank'>
								<img src={imgHallChadwickLogo} alt='powered by Hall Chadwick Forensics' />
							</a>
						</div><div className='header__slot header__slot--middle'>
							<NavLink className='header__slot__logo' to={logo_link}>
								<img src={imgXpediteLogo} alt='Xpedite' />
							</NavLink>
						</div>{header_right}</div>

				</header>
				<header className='print print--header'>

					<div className='wrapper clearfix'>

						<div className='pull-left'>
							<img src={imgPrintHCLogo} alt='Hall Chadwick' />
						</div>

						<div className='pull-right'>
							<img src={imgPrintXPLogo} alt='Xpedite' />
						</div>

						{print_middle}

					</div>

				</header>
			</Cluster>
		);

	}

}

const mapStateToProps = state => {
	return {
		user: state.user,
		matter: state.matter
	};
}


export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/Blocks/Header.js